<template>
  <div class="article-wrapper">
    <docs-sidebar-container></docs-sidebar-container>
    <toolbar-view
      :highlight-save="!docSaved"

      @export="onExport('doc')"

      @save="onSave"
      @open="onLoad"

      @undo="onEditorAction('editorUndo')"
      @redo="onEditorAction('editorRedo')"

      @copy="onEditorAction('editorCopy')"
      @cut="onEditorAction('editorCut')"
      @paste="onEditorAction('editorPaste')"

      @header="onEditorAction('editorHeader')"
      @list="onEditorAction('editorList')"

      @add-source="openAddSourceDialog"
    ></toolbar-view>
    <article-view
      ref="editor"
      :links="linksLabels"
      :content-html="contentHtml"
      @input="onChangeContent"
      @add-source="openAddSourceDialog"
      @edit-link='onEditLink'
      @set-doc-name="onSetDocName"
      @export="onExport"
    >
      <lit-list-container
        slot="lit-list"
        :sources="sources"
      ></lit-list-container>
    </article-view>
    <!--
    <input type="text" v-model="id"/>
    <button @click="onGet">Получить</button>
    -->
    <export-container
      ref="exportContainer"
    ></export-container>
    <source-dialog-container
    	ref="sourceDialog"
      @add-link="onAddLink"
    ></source-dialog-container>
    <base-timer
      :timeout="5000"
      @timer="onSaveTimer"
    ></base-timer>
  </div>
</template>
<script>
import parser from 'elib-parser'

import LitListContainer from './LitListContainer.vue'
import ArticleView from './ArticleView.vue'
import SourceDialogContainer from './SourceDialogContainer.vue'
import ExportContainer from './ExportContainer.vue'
import ToolbarView from './ToolbarView.vue'
import DocsSidebarContainer from './DocsSidebarContainer.vue'
import BaseTimer from '@/components/BaseTimer.vue'

import _ from 'lodash'
import draggable from 'vuedraggable'
import identifier from 'identifier'
import getOrderedLinks from '@/shared/getOrderedLinks'

import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'ArticleContainer',
  components: {
    BaseTimer,
    LitListContainer,
    ArticleView,
    SourceDialogContainer,
    DocsSidebarContainer,
    ExportContainer,
    ToolbarView,
    draggable
  },
  data () {
    return {
      id: '28834698',
      title: '',
      items: [],
      links: {},
      sources: {},
      contentUpdating: false
    };
  },
  computed: {
    ...mapState({
      contentHtml: state => state.contentHtml,
      isAuthorized: state => state.isAuthorized,
      docSaved: state => state.docSaved,
      docName: state => state.docName
    }),
    ...mapGetters(['linksLabels']),
    formattedLinks () {
      let result = {}
      Object.keys(this.links).forEach((linkId) => {
        let labels = []
        this.links[linkId].sources.forEach((sourceId) => {
          labels.push(this.sources[sourceId].number)
        })
        result[linkId] = '[' + lablinksLabelsels.join(', ') + ']'
      })
      return result
    }
  },
  watch: {
    contentHtml (content) {
      if (this.contentUpdating) {
        this.contentUpdating = false
      } else {
        this.$refs.editor.forceUpdateContent(content)
      }
    }
  },
  mounted () {
    window.addEventListener('beforeunload', this.onUnload)
  },
  beforeDestory () {
    window.removeEventListener('beforeunload', this.onUnload)
  },
  methods: {
    ...mapActions(['setContentHtml', 'addSource', 'addLink', 'saveDoc', 'loadDoc', 'renameDoc']),
    onSave () {
      if (!this.isAuthorized) {
        this.login(this.saveDoc)
      } else {
        this.saveDoc().then().catch((err) => {
          this.handleError(err)
        })
        this.showCommonMessage('Документ сохранен')
      }
    },
    onSaveTimer () {
      if (this.isAuthorized && !this.docSaved) {
        this.saveDoc().then().catch((err) => {
          this.handleError(err)
        })
      }
    },
    onSetDocName (newDocName) {
      this.renameDoc({ oldDocName: this.docName, newDocName })
    },
    onUnload (e) {
      if (!this.docSaved) {
        var confirmationMessage = 'Документ не сохранен. Вы точно хотите закрыть окно?'
        e.returnValue = confirmationMessage
        return confirmationMessage
      }
    },
    onLoad () {
      if (!this.isAuthorized) {
        this.login(this.loadDoc)
      } else {
        this.loadDoc()
      }
    },
    onEditorAction (action) {
      if (this.$refs.editor) {
        this.$refs.editor[action]()
      }
    },
    onExport (format) {
      this.$refs.exportContainer.export(format)
    },
    onItemRemove (item) {
      this.items = _.without(this.items, item)
    },
    onChangeContent (content) {
      if (content !== this.contentHtml) {
        this.contentUpdating = true
        this.setContentHtml(content)
      }
    },
    openAddSourceDialog () {
      this.$refs.sourceDialog.reset()
      this.$refs.sourceDialog.add()
    },
    onAddLink (linkId) {
      this.$refs.editor.addLink(linkId)
    },
    onEditLink (linkId) {
      this.$refs.sourceDialog.edit(linkId)
    },
    login (callback) {
      this.$emit('auth', callback)
    }
  }
}
</script>


// WEBPACK FOOTER //
// ArticleContainer.vue?543aac86